import React, { useEffect, useState, createContext } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { FirebaseAuth, ModularAuth } from "./firebase";

export const AuthContext = createContext();
const MAX_AUTH_AGE_MS = 24 * 60 * 60 * 1000;

export const AuthProvider = ({ children }) => {
    const [authUser, setAuthUser] = useState({
      'user': null,
      'checked': false,
      'role': null
    });

    const [userData, setUserData] = useState({

    });
  
    useEffect(() => {
      const unsubscribe = onAuthStateChanged(ModularAuth, function(user){
        if(user !== null){
          user.getIdTokenResult().then(tokenResult => {
            const authTimeSec = Number(tokenResult?.claims?.auth_time || 0);
            const authAgeMs = authTimeSec > 0 ? (Date.now() - authTimeSec * 1000) : 0;

            if (authAgeMs > MAX_AUTH_AGE_MS) {
              signOut(ModularAuth);
              setAuthUser({
                'user': null,
                'checked': true,
                'role': null
              });
              return;
            }
            FirebaseAuth
              .firestore()
              .collection('users')
              .doc(user.uid)
              .get()
              .then((userDoc) => {
                const profile = userDoc.exists ? (userDoc.data() || {}) : {};
                const authDisplayName = String(user.displayName || "").trim();
                const docDisplayName = String(profile.display_name || "").trim();
                if (authDisplayName && authDisplayName !== docDisplayName) {
                  FirebaseAuth
                    .firestore()
                    .collection('users')
                    .doc(user.uid)
                    .set(
                      {
                        display_name: authDisplayName,
                        updated_at: new Date(),
                      },
                      { merge: true }
                    )
                    .catch(() => null);
                }
                // const role = profile.role || (profile.account_created ? 'contractor' : null);
                const role = profile.role || null;
                setAuthUser({
                  'user': user,
                  'checked': true,
                  'role': role
                });
              })
              .catch(() => {
                setAuthUser({
                  'user': user,
                  'checked': true,
                  'role': null
                });
              });
          }).catch(function(error) {
            console.log("Invalid ID token !");
            setAuthUser({
              'user': null,
              'checked': true,
              'role': null
            });
          });
        }else{
          setAuthUser({
            'user': null,
            'checked': true,
            'role': null
          });
        }
      });
      return () => unsubscribe();
    }, []);
  
    return (
      <AuthContext.Provider
        value={{
          authUser, userData, setUserData
        }}
      >
        {children}
      </AuthContext.Provider>
    );
  };
